import {useCallback} from 'react'
import {
  useContactCreateListMutation,
  useContactDeleteListMutation,
  useContactUpdateListMutation,
} from '../../../../../services/cellcast.v2'
import {List} from '../../../../../services/cellcast.v3.types'
import {getIsDefaultRegion} from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import {useSelector} from 'react-redux'
import {useDeleteTagMutation, useUpsertTagMutation} from '../../../../../services/cellcast.v3'
import {toast} from 'react-toastify'

export function useWriteList() {
  const isDefaultRegion = useSelector(getIsDefaultRegion)

  const [createList, {isLoading: createListLoading}] = useContactCreateListMutation()
  const [updateList, {isLoading: updateListLoading}] = useContactUpdateListMutation()
  const [deleteList, {isLoading: deleteListLoading}] = useContactDeleteListMutation()
  const [writeRegionList, {isLoading: writeRegionLoading}] = useUpsertTagMutation()
  const [deleteRegionList, {isLoading: deleteRegionLoading}] = useDeleteTagMutation()

  const handleCreate = useCallback(
    (data: { name: string}, callbackFn?: () => void) => {
      if (isDefaultRegion) {
        createList({name: data.name})
          .then((res) => {
            if ('data' in res) {
              toast.success(res.data?.message)

              if (callbackFn) {
                callbackFn()
              }
            } else if ('error' in res) {
              const errObj = res.error as any
              if (errObj.data.message) {
                toast.error(errObj.data.message)
              } else {
                toast.error(res.error)
              }
            }
          })
          .catch((err) => {
            toast.error(err.error)
          })
      } else {
        writeRegionList({
          action: 'create_tag',
          data: {
            name: data.name,
            type: 'list',
          },
        })
          .then((res) => {
            if ('data' in res) {
              toast.success(res.data?.message)

              if (callbackFn) {
                callbackFn()
              }
            } else if ('error' in res) {
              const errObj = res.error as any
              if (errObj.data.message) {
                toast.error(errObj.data.message)
              } else {
                toast.error(res.error)
              }
            }
          })
          .catch((err) => {
            toast.error(err.error)
          })
      }
    },
    [createList, isDefaultRegion, writeRegionList]
  )

  const handleUpdate = useCallback(
    (data: { _id: string, name: string}, callbackFn?: () => void) => {
      if (isDefaultRegion) {
        updateList({_id: data._id, name: data.name})
          .then((res) => {
            if ('data' in res) {
              toast.success(res.data?.message)

              if (callbackFn) {
                callbackFn()
              }
            } else if ('error' in res) {
              const errObj = res.error as any
              if (errObj.data.message) {
                toast.error(errObj.data.message)
              } else {
                toast.error(res.error)
              }
            }
          })
          .catch((err) => {
            toast.error(err.error)
          })
      } else {
        writeRegionList({
          action: 'update_tag',
          data: {
            name: data.name,
            tag_id: data?._id,
          },
        })
          .then((res) => {
            if ('data' in res) {
              toast.success(res.data?.message)
              if (callbackFn) {
                callbackFn()
              }
            } else if ('error' in res) {
              const errObj = res.error as any
              if (errObj.data.message) {
                toast.error(errObj.data.message)
              } else {
                toast.error(res.error)
              }
            }
          })
          .catch((err) => {
            toast.error(err.error)
          })
      }
    },
    [updateList, isDefaultRegion, writeRegionList]
  )

  const handleDelete = useCallback(
    (ids: string[], callbackFn?: () => void) => {
      if (isDefaultRegion) {
        deleteList({
          ids: ids,
        })
          .then((res) => {
            if ('data' in res) {
              toast.success(res.data?.message)
            } else if ('error' in res) {
              toast.error(res.error)
            }
            if (callbackFn) {
              callbackFn()
            }
          })
          .catch((err) => {
            toast.error(err.error)
          })
          .finally(() => {
            if (callbackFn) {
              callbackFn()
            }
          })
      } else {
        deleteRegionList(ids)
          .then((res) => {
            if ('data' in res) {
              toast.success(res.data?.message)
            } else if ('error' in res) {
              toast.error(res.error)
            }
          })
          .finally(() => {
            if (callbackFn) {
              callbackFn()
            }
          })
      }
    },
    [deleteList, deleteRegionList, isDefaultRegion]
  )

  return {
    createHandler: handleCreate,
    createLoading: createListLoading || writeRegionLoading,
    updateHandler: handleUpdate,
    updateLoading: updateListLoading || writeRegionLoading,
    deleteHandler: handleDelete,
    deleteLoading: deleteListLoading || deleteRegionLoading,
  }
}
